import axios from "axios";
import { ENDPOINTS, getBaseURL } from "data/endpoints";
import { getHeaders } from "data/headers";

export const getShoppingApi = () => {
  return axios.get(getBaseURL() + ENDPOINTS.SHOPPING_LIST, {
    headers: getHeaders(),
  });
};
